import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(f.name, f.email, f.password);
      toast.success("Account created — welcome!");
      nav("/my-bookings");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="eyebrow mb-3" style={{ color: "#0B1F3A" }}>Join the fleet</div>
      <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-8">Create an account</h1>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-black/5 p-8 space-y-4">
        <Field label="Full name" value={f.name} onChange={(v) => setF({ ...f, name: v })} testId="register-name" />
        <Field label="Email" type="email" value={f.email} onChange={(v) => setF({ ...f, email: v })} testId="register-email" />
        <Field label="Password" type="password" value={f.password} onChange={(v) => setF({ ...f, password: v })} testId="register-password" />
        <button data-testid="register-submit" className="btn-gold w-full justify-center" disabled={busy}>{busy ? "Creating account…" : "Create account"}</button>
        <div className="text-sm text-center text-[#0B1F3A]/60">
          Already have an account? <Link to="/login" className="text-[#D4AF37] font-medium">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
function Field({ label, value, onChange, type = "text", testId }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.2em] text-[#0B1F3A]/60">{label}</span>
      <input type={type} value={value} required data-testid={testId}
        onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full border border-[#0B1F3A]/15 rounded-lg px-3 py-2.5 outline-none focus:border-[#D4AF37]" />
    </label>
  );
}
